export default {"src":"/_next/static/media/elment1.699ad226.svg","height":62,"width":91,"blurWidth":0,"blurHeight":0};